import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import { environment } from '../../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class UploadService {
  constructor(private http: HttpClient) {}

  uploadImage(resourceName: string, fileContent: any): Observable<any> {
    return this.upload('image', resourceName, fileContent)
  }

  uploadFile(resourceName: string, fileContent: any): Observable<any> {
    return this.upload('file', resourceName, fileContent)
  }

  private upload(
    uploadType: string,
    resourceName: string,
    fileContent: any
  ): Observable<any> {
    const formData = new FormData()

    formData.append('file', fileContent)
    formData.append('resourceName', resourceName)

    return this.http
      .post(`${environment.apiBaseUrl}/upload/${uploadType}`, formData)
      .pipe(
        map((response: { path: string }) => {
          return response
        })
      )
  }
}
